import { render, staticRenderFns } from "./new-request-button.vue?vue&type=template&id=affed9a2&"
import script from "./new-request-button.vue?vue&type=script&lang=js&"
export * from "./new-request-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports